import { DatePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';

type Props = {
	name: string;
	label?: string;
	value: string;
	required: boolean;
	isError: boolean;
	onChange: (value: string) => void;
	placeholder?: string;
	helperText?: string;
	disabled?: boolean;
	picker?: 'date' | 'month' | 'year';
	disabledBeforeDates?: any;
	disabledAfterDates?: any;
	isViewOnly?: boolean;
	disableSunday?: boolean;
	style?: any;
};

const DatePickerFieldForLeave = (props: Props) => {
	const {
		name,
		label,
		value,
		placeholder,
		isError = false,
		required = false,
		onChange,
		disabled = false,
		helperText = 'Date is required',
		picker = 'date',
		disabledBeforeDates,
		disabledAfterDates,
		isViewOnly = false,
		disableSunday = false,
		style,
	} = props;

	const handleChange = (value: string) => {
		onChange(value);
	};

	const calculateMaxDate = (startDate: string, maxLeaves: number): Dayjs => {
		let currentDate = dayjs(startDate);
		let daysToAdd = 0;
		let leavesCount = 0;

		while (leavesCount < maxLeaves) {
			daysToAdd++;
			const dateToCheck = currentDate.add(daysToAdd, 'day');
			if (dateToCheck.day() !== 0) {
				// Skip Sundays
				leavesCount++;
			}
		}

		return currentDate.add(daysToAdd, 'day');
	};

	return (
		<div className="input-field" style={{ ...style }}>
			{label && (
				<p
					className="label"
					style={{ marginBottom: `${isViewOnly ? '5px' : ''}` }}
				>
					{label}{' '}
					{required && !isViewOnly && <span className="red">*</span>}
				</p>
			)}
			{isViewOnly ? (
				<p>{dayjs(value).format('DD/MM/YYYY')}</p>
			) : (
				<div>
					<DatePicker
						name={name}
						value={value}
						size="large"
						onChange={handleChange}
						format={
							picker === 'year'
								? 'YYYY'
								: picker === 'month'
								? 'MMM, YYYY'
								: 'DD/MM/YYYY'
						}
						disabled={disabled}
						placeholder={placeholder}
						style={{ width: '100%' }}
						status={isError ? 'error' : ''}
						picker={picker}
						disabledDate={(current: Dayjs) => {
							if (
								disabledBeforeDates &&
								current < dayjs(disabledBeforeDates)
							) {
								return true;
							}

							if (disableSunday && current.day() === 0) {
								return true;
							}

							if (disabledAfterDates) {
								const maxDate = calculateMaxDate(
									disabledBeforeDates,
									typeof disabledAfterDates === 'number'
										? disabledAfterDates
										: dayjs(disabledAfterDates).diff(
												dayjs(disabledBeforeDates),
												'day'
										  )
								);
								return current > maxDate;
							}

							return false;
						}}
						allowClear={false}
					/>
					{isError && (
						<p
							className="red"
							style={{
								fontSize: '12px',
								marginLeft: '2px',
							}}
						>
							{helperText}
						</p>
					)}
				</div>
			)}
		</div>
	);
};

export default DatePickerFieldForLeave;
